import React from 'react';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 pb-5 border-b border-[#D8D0C4]/70">
      <div className="min-w-0">
        <h1 className="font-display font-semibold text-2xl md:text-3xl tracking-[-0.01em] text-charcoal">
          {title}
        </h1>
        {subtitle && (
          <div className="mt-1.5 text-sm text-[#8A877F] max-w-3xl">{subtitle}</div>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
